import React, { Fragment, useState, useEffect } from "react";
import SearchIcon from "../../assets/images/dashboardCounselor/search.png";
import editIcon from "../../assets/images/CouselorMessages/edit.png";
import messageSummary from "../../assets/images/CounselorMessage/message_summary.png";
import MessageList from "../singlemessage/messageList";
import SingleMessage from "../singlemessage/singleMessage";
import CustomLoader from "../customLoader/CustomLoader";
import ModalExample from "../newMessageModal/NewMessageModal";
// Removed MUI style pagination; using custom icon pagination like counselorStudentMessage
// import CustomPagination from "../pagination/Pagination";
import { useHistory, useLocation } from "react-router-dom";
import GetMsgService from "../../services/MsgService";
import { useSelector, useDispatch } from "react-redux";
import { messageNotificationAction } from "../../reducers/MessageNotificationReducer";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import MsgDataService from "../../services/MsgService";
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const Message = () => {
  let hist = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  let studentOrCounselor = location.pathname.split("/")[2];
  // console.log("location from the change", location, studentOrCounselor);
  const [msg, setMsg] = useState();
  const [list, setList] = useState();
  const [filterList, setFilterList] = useState();
  const [selectedMessageIndex, setSelectedMsgIndex] = useState();
  const [showSingleMessageComponent, setShowSingleMessageComponent] = useState(
    false
  );
  const [selectedMessage, setSelectedMessage] = useState();
  const [searchMsg, setSearchMsg] = useState();
  //console.log("data for location",location && location.state && location.state.openMessageModal);
  const [open, setOpen] = useState(location["openMessageModal"]);
  const [isStudentOrCounselor, setIsStudentOrCounselor] = useState(
    studentOrCounselor
  );
  const [page, setPage] = useState(1);
  const [msgData, setMsgData] = useState();
  const [loading, setLoading] = useState(false);
  const [NameOrGroupName, setNameOrGroupName] = useState();
  const [
    selectedGroupMessageStudent,
    setSelectedGroupMessageStudent,
  ] = useState(location && location.state);
  const [showNotificationAlert, setShowNotificationAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [numberOfStudents, setNumberOfStudents] = useState(
    location["payloadForSaveResult"]
  );
  const [studentCountData, setStudentCountData] = useState();
  const [internationalCountData, setInternationalCountData] = useState();
  const [counselorCountData, setCounselorCountData] = useState();
  const [selectedUserMsgList, setSelectedUserMsgList] = useState();
  const [notificationData, setNotificationData] = useState(null); // Add notification data like StudentMessage
  let user = useSelector((state) => state.UserReducer.userObj);

  useEffect(() => {
    async function getSelectedNessageStudent() {
      // console.log("Processing selectedGroupMessageStudent in Message.js:", selectedGroupMessageStudent);

      if (Array.isArray(selectedGroupMessageStudent)) {
        // console.log("Setting NameOrGroupName to full student array:", selectedGroupMessageStudent);
        // Keep the full student data, don't just extract IDs
        await setNameOrGroupName(selectedGroupMessageStudent);
      } else if (
        typeof selectedGroupMessageStudent === "string" &&
        selectedGroupMessageStudent === "selected All"
      ) {
        // console.log("Setting NameOrGroupName to 'selected All'");
        setNameOrGroupName("selected All");
      } else {
        // console.log("Setting NameOrGroupName to:", selectedGroupMessageStudent);
        setNameOrGroupName(selectedGroupMessageStudent);
      }
    }

    getSelectedNessageStudent();
  }, [selectedGroupMessageStudent]);

  useEffect(() => {
    setTimeout(() => {
      setShowSuccessAlert(false);
    }, 3500);
  }, [showSuccessAlert]);

  useEffect(() => {
    setTimeout(() => {
      setShowErrorAlert(false);
    }, 3500);
  }, [showErrorAlert]);

  useEffect(() => {
    {
      showStudentOrCounselor &&
        (user.is_premium || !user.is_premium) &&
        getUnreadCount();
    }
    {
      showInternationalStudent && getUnreadCount();
    }
  }, []);

  const getUnreadCount = () => {
    MsgDataService.getUnreadCountForStudent()
      .then((res) => {
        if (res?.status === 200) {
          const { student, international, counselor } = res?.data || {};

          // Store raw notification data for MessageList component
          setNotificationData({
            student: student || {},
            international: international || {},
            counselor: counselor || {},
          });

          if (student) {
            setStudentCountData(
              Object.values(student).reduce((total, count) => total + count, 0)
            );
          } else {
            setStudentCountData(0);
          }

          if (international) {
            setInternationalCountData(
              Object.values(international).reduce(
                (total, count) => total + count,
                0
              )
            );
          } else {
            setInternationalCountData(0);
          }

          if (counselor) {
            setCounselorCountData(
              Object.values(counselor).reduce(
                (total, count) => total + count,
                0
              )
            );
          } else {
            setCounselorCountData(0);
          }
        }
      })
      .catch((error) => {
        console.error("error from the service", error);
      });
  };

  // Refresh counselor header bell count right away
  const refreshHeaderNotification = () => {
    return MsgDataService.getCounselorNotificationCount()
      .then((res) => {
        const total = res?.data?.total_notification ?? 0;
        try { dispatch(messageNotificationAction(total)); } catch (_) {}
      })
      .catch(() => {});
  };

  const getMsgData = () => {
    setLoading(true);
    let body =
      isStudentOrCounselor === "counselors"
        ? "recruiter_counselor"
        : isStudentOrCounselor === "students"
        ? "recruiter_student"
        : isStudentOrCounselor === "international-students"
        ? "international_student"
        : null;
    GetMsgService.getMsgRecruiterData(page, body)
      .then((data) => {
        setMsgData({ ...data?.data, max: data?.data?.page_count });
        let searchArr = data?.data?.data?.map((item) => item);
        setList(searchArr);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  };

  const handleChangeSearchMsg = (e) => {
    setSearchMsg(e.target.value);
    let arr1 = [];
    let filterArr = [];
    if (list) {
      filterArr = list.filter((item, index) => {
        let ans = item?.name
          .toLowerCase()
          .replace(/ +/g, "")
          .match(e?.target?.value?.toLowerCase()?.replace(/ +/g, ""));
        //   ||
        // item?.src_role
        //   .toLowerCase()
        //   .replace(/ +/g, "")
        //   .match(e?.target?.value?.toLowerCase()?.replace(/ +/g, ""));

        if (ans) {
          arr1.push(index);
        }
        return ans;
      });
    }
    let arr2 = arr1.map((item, index) => msgData.data[item]);
    setFilterList(arr2);
  };

  const handleIsStudentOrCounselor = (value) => {
    setIsStudentOrCounselor(value);
    if (value === "students") hist.push("/recruiter/students");
    if (value === "international-students")
      hist.push("/recruiter/international-students");
    if (value === "counselors") hist.push("/recruiter/counselors");
  };

  const closeHandler = () => {
    // console.log("getting called from closeHandler");
    setOpen(false);
    setMsg("");
    setNameOrGroupName("");
    setSelectedGroupMessageStudent([]);
  };

  const selectMessage = (item, index) => {
    setSelectedMsgIndex(index);
    setSelectedMessage(item);
    getReadCountbyDate(item.src_id);
    getSelectedContactMessageDetail(item);
    setShowSingleMessageComponent(true);
    // Also ensure header bell updates when we open/read a thread
    refreshHeaderNotification();
  };

  const openMessageHandler = () => {
    setOpen(true);
  };
  useEffect(() => {
    setShowSingleMessageComponent(false);
    setSelectedMessage();
    setSelectedMsgIndex();
  }, [isStudentOrCounselor]);

  useEffect(() => {
    {
      showStudentOrCounselor &&
        (user.is_premium || !user.is_premium) &&
        getMsgData();
    }
    {
      showInternationalStudent && getMsgData();
    }
  }, [page]);

  const getSelectedContactMessageDetail = (item) => {
    MsgDataService.getMessageListPerUser(page, item.src_id).then((data) => {
      setSelectedUserMsgList(data.data.messages);
    });
  };

  const getReadCountbyDate = (id) => {
    let payload = {
      src_id: id,
    };
    setLoading(true);
    MsgDataService.readCountDate(payload)
      .then((res) => {
        if (res?.status === 200) {
          // console.log("date res", res);
          setLoading(true);
          getUnreadCount();
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("error from the service", error);
        setLoading(false);
      });
  };

  // Helper function to calculate circle size based on digit count
  const getCircleSize = (count) => {
    const digits = String(count || 0).length;
    if (digits === 1) return { width: "45px", height: "45px" };
    if (digits === 2) return { width: "52px", height: "52px" };
    if (digits === 3) return { width: "58px", height: "58px" };
    if (digits === 4) return { width: "65px", height: "65px" };
    if (digits === 5) return { width: "72px", height: "72px" };
    return { width: "80px", height: "80px" }; // For 6+ digits
  };

  let showStudentOrCounselor = false;
  let showInternationalStudent = false;
  let showPremiumMessage = false;
  let summaryType = "STUDENT";
  let newMessagesLabel = "";

  if (
    isStudentOrCounselor === "students" ||
    isStudentOrCounselor === "counselors"
  ) {
    showStudentOrCounselor = true;
    newMessagesLabel =
      isStudentOrCounselor === "counselors"
        ? "NEW COUNSELOR MESSAGES"
        : "NEW STUDENT MESSAGES";
  } else if (isStudentOrCounselor === "international-students") {
    if (user.is_premium) {
      showInternationalStudent = true;
      newMessagesLabel = "NEW INTERNATIONAL STUDENT MESSAGES";
    } else {
      showPremiumMessage = true;
    }
  }

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="main_container">
            {showNotificationAlert && (
              <div
                style={{ padding: "15px 35px" }}
                className="notification_alert"
              >
                <p className="no-margin-bottom">
                  {/* We are sending your messages.. */}
                  Message sending is under process. Once done, you will get a
                  notification in the registered mail.
                </p>
              </div>
            )}
            {showSuccessAlert && (
              <div style={{ padding: "15px 35px" }} className="success_alert">
                <p className="no-margin-bottom">
                  Your Messages have been sent..
                </p>
              </div>
            )}
            {showErrorAlert && (
              <div style={{ padding: "15px 35px" }} className="error_alert">
                <p className="no-margin-bottom">
                  Your Messages were not sent, due to some technical
                  reason.Please Try again after some time!!
                </p>
              </div>
            )}
            <div style={{ padding: "35px", height: "100%" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                {loading ? (
                  <div className="loading">
                    {" "}
                    <CustomLoader />{" "}
                  </div>
                ) : (
                  <>
                    {/* Updated tab navigation with modern styling */}
                    <div
                      className="current-student-tabs-container"
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "15px",
                        background: "transparent",
                      }}
                    >
                      <div
                        onClick={() => handleIsStudentOrCounselor("students")}
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "students"
                            ? "active-tab"
                            : ""
                        }`}
                        style={{
                          width: "auto",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 24px",
                        }}
                      >
                        <span>Students</span>
                      </div>

                      <div
                        onClick={() =>
                          handleIsStudentOrCounselor("international-students")
                        }
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "international-students"
                            ? "active-tab"
                            : ""
                        }`}
                        style={{
                          width: "auto",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 24px",
                        }}
                      >
                        <span>International Students</span>
                      </div>

                      <div
                        onClick={() => handleIsStudentOrCounselor("counselors")}
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "counselors"
                            ? "active-tab"
                            : ""
                        }`}
                        style={{
                          width: "auto",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 24px",
                        }}
                      >
                        <span>Counselors</span>
                      </div>
                    </div>

                    {/* Updated Summary section with new styling like StudentMessage */}
                    {(showStudentOrCounselor || showInternationalStudent) &&
                      (user.is_premium || !user.is_premium) && (
                        <div
                          style={{
                            margin: "15px 0",
                            background: "transparent",
                          }}
                        >
                          <div
                            className="flex"
                            style={{
                              alignItems: "center",
                              padding: "20px 30px",
                              justifyContent: "flex-start",
                              gap: "40px",
                            }}
                          >
                            {/* Left side - Summary with icon */}
                            <div
                              className="flex"
                              style={{ alignItems: "center", gap: "15px" }}
                            >
                              <div
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  borderRadius: "50%",
                                  background: "#2cb34a",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={messageSummary}
                                  alt="Message Summary"
                                  style={{ width: "24px", height: "24px" }}
                                />
                              </div>
                              <div>
                                <p
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    marginBottom: "0px",
                                    color: "#333",
                                  }}
                                >
                                  {isStudentOrCounselor === "students"
                                    ? "Students"
                                    : isStudentOrCounselor ===
                                      "international-students"
                                    ? "International Students"
                                    : "Counselors"}{" "}
                                  Summary
                                </p>
                              </div>
                            </div>

                            {/* Same row - Message counts */}
                            {/* Total Messages */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "8px 16px",
                                border: "2px solid #fff",
                                borderRadius: "25px",
                                background: "#fff",
                                transition: "border-color 0.3s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border = "2px solid #0046A0")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border = "2px solid #fff")
                              }
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#333",
                                }}
                              >
                                Total Messages
                              </span>
                              <div
                                style={{
                                  backgroundColor: "#0046A0",
                                  borderRadius: "50%",
                                  ...getCircleSize(msgData?.total_count || 0),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#fff",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {msgData?.total_count || 0}
                                </span>
                              </div>
                            </div>

                            {/* New Messages */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "8px 16px",
                                border: "2px solid #fff",
                                borderRadius: "25px",
                                background: "#fff",
                                transition: "border-color 0.3s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border = "2px solid #009900")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border = "2px solid #fff")
                              }
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#333",
                                }}
                              >
                                {isStudentOrCounselor === "students"
                                  ? "New Student Messages"
                                  : isStudentOrCounselor ===
                                    "international-students"
                                  ? "New International Student Messages"
                                  : "New Counselor Messages"}
                              </span>
                              <div
                                style={{
                                  backgroundColor: "#009900",
                                  borderRadius: "50%",
                                  ...getCircleSize(
                                    isStudentOrCounselor === "students"
                                      ? studentCountData || 0
                                      : isStudentOrCounselor ===
                                        "international-students"
                                      ? internationalCountData || 0
                                      : counselorCountData || 0
                                  ),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#fff",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {isStudentOrCounselor === "students"
                                    ? studentCountData || 0
                                    : isStudentOrCounselor ===
                                      "international-students"
                                    ? internationalCountData || 0
                                    : counselorCountData || 0}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {showPremiumMessage && (
                      <div style={{ margin: "20px 0px 0px 15px" }}>
                        <span>
                          This is for <strong>Premium Users.</strong> For more
                          details please contact to <strong>Admin.</strong>
                        </span>
                        <br />
                        <br />
                      </div>
                    )}

                    {/* Modern container design like StudentMessage */}
                    <div
                      className="counselor-msg-container"
                      style={{
                        background: "#ffffff",
                        border: "2px solid #90caf9",
                        borderRadius: "12px",
                        padding: "25px",
                        display: "flex",
                        gap: "30px",
                        alignItems: "stretch",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        height: "800px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          flex: "0 0 38%",
                          maxWidth: "430px",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "10px",
                          overflow: "hidden",
                        }}
                      >
                        {/* Header with search and new message button */}
                        {(showStudentOrCounselor || showInternationalStudent) &&
                          (user.is_premium || !user.is_premium) && (
                            <div style={{ padding: "0 15px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "20px",
                                }}
                              >
                                <p
                                  style={{
                                    marginBottom: 0,
                                    fontWeight: 600,
                                    fontSize: 18,
                                  }}
                                >
                                  Messages
                                </p>
                                <div style={{ display: "flex", gap: "12px" }}>
                                  <button
                                    onClick={openMessageHandler}
                                    className="download-reflections-btn"
                                    style={{
                                      background: "#009900",
                                      borderColor: "#009900",
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 16px",
                                      borderRadius: "6px",
                                      color: "white",
                                      border: "none",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: 20,
                                        height: 20,
                                        marginRight: 8,
                                      }}
                                      src={editIcon}
                                      alt="New Message"
                                    />
                                    New Message
                                  </button>
                                </div>
                              </div>
                              <div
                                className="current-student-search-input"
                              style={{
                                position: "relative",
                                display: "flex",
                                padding: "12px",
                                marginTop: "12px",
                                marginBottom: "12px",
                                width: "100%",
                              }}
                              >
                                <input
                                  style={{
                                  backgroundColor: "#fff",
                                  paddingLeft: "20px",
                                  opacity: 1,
                                  flex: 1,
                                }}
                                  type="text"
                                  className="search-contact"
                                  placeholder="Search Messages"
                                  name="searchMsg"
                                  value={searchMsg}
                                  autoComplete="off"
                                  onChange={handleChangeSearchMsg}
                                />
                                <div className="search-icon-holder">
                                  <img
                                    src={SearchIcon}
                                    alt="Search"
                                    style={{
                                      position: "absolute",
                                      right: "16px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: "20px",
                                      height: "20px",
                                      opacity: 0.7,
                                      pointerEvents: "none",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                        {/* Scrollable message list area */}
                        <div
                          style={{
                            padding: "0px 15px",
                            flex: 1,
                            overflowY: "auto",
                          }}
                        >
                          {msgData && (
                            <>
                              {isStudentOrCounselor === "students" &&
                                (user.is_premium || !user.is_premium) && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={getMsgData}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    onAfterMarkRead={() => {
                                      // After list triggers notification API, refresh local counts and header
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}

                              {isStudentOrCounselor === "counselors" &&
                                (user.is_premium || !user.is_premium) && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={getMsgData}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    onAfterMarkRead={() => {
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}

                              {isStudentOrCounselor ===
                                "international-students" &&
                                user.is_premium && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={getMsgData}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    onAfterMarkRead={() => {
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}
                            </>
                          )}
                        </div>
                      </div>

                      <div
                        className="single-message-container"
                        style={{
                          flex: 1,
                          minHeight: "520px",
                          display: "flex",
                          overflow: "hidden",
                        }}
                      >
                        {showSingleMessageComponent && (
                          <div style={{ width: "100%", height: "100%" }}>
                            <SingleMessage
                              msgData={selectedMessage && selectedMessage}
                              conversition={
                                selectedUserMsgList && selectedUserMsgList
                              }
                              isStudentOrCounselor={isStudentOrCounselor}
                              setShowSingleMessageComponent={
                                setShowSingleMessageComponent
                              }
                              getMsgData={getMsgData}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {/* Custom simple pagination (prev | current | next) similar to counselorStudentMessage */}
                {(showStudentOrCounselor || showInternationalStudent) &&
                  (user.is_premium || !user.is_premium) &&
                  msgData && (
                    <div
                      className="counselor-student-container custom-pagination-wrapper"
                      style={{
                        marginTop: "18px",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingRight: "10px",
                      }}
                    >
                      <div
                        className="custom-pagination"
                        style={{
                          marginLeft: "auto",
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <button
                          type="button"
                          aria-label="Previous"
                          className={`pagination-btn ${
                            page === 1 ? "disabled" : ""
                          }`}
                          onClick={() => page > 1 && setPage(page - 1)}
                          style={{
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            cursor: page === 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          <img
                            src={page === 1 ? pageLeftHide : pageLeft}
                            alt="Prev"
                            className="pagination-img"
                            style={{ width: 28, height: 28 }}
                          />
                        </button>
                        <div
                          className="pagination-center"
                          style={{
                            position: "relative",
                            width: 40,
                            height: 40,
                          }}
                        >
                          <img
                            src={pageCenter}
                            alt="Page"
                            className="pagination-img"
                            style={{ width: "100%", height: "100%" }}
                          />
                          <span
                            className="pagination-number"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              fontWeight: 600,
                              color: "#fff",
                            }}
                          >
                            {page}
                          </span>
                        </div>
                        <button
                          type="button"
                          aria-label="Next"
                          className={`pagination-btn ${
                            page >= (msgData?.max || msgData?.page_count || 1)
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() =>
                            page < (msgData?.max || msgData?.page_count || 1) &&
                            setPage(page + 1)
                          }
                          style={{
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            cursor:
                              page >= (msgData?.max || msgData?.page_count || 1)
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <img
                            src={pageRight}
                            alt="Next"
                            className="pagination-img"
                            style={{ width: 28, height: 28 }}
                          />
                        </button>
                      </div>
                    </div>
                  )}

                <ModalExample
                  open={open}
                  closeHandler={closeHandler}
                  getMsgData={getMsgData}
                  isStudentOrCounselor={isStudentOrCounselor}
                  NameOrGroupName={NameOrGroupName}
                  setNameOrGroupName={setNameOrGroupName}
                  msg={msg}
                  setMsg={setMsg}
                  setOpen={setOpen}
                  selectedGroupMessageStudent={selectedGroupMessageStudent}
                  setShowSuccessAlert={setShowSuccessAlert}
                  setShowErrorAlert={setShowErrorAlert}
                  setShowNotificationAlert={setShowNotificationAlert}
                  setSelectedGroupMessageStudent={
                    setSelectedGroupMessageStudent
                  }
                  numberOfStudents={numberOfStudents}
                  page={location?.state?.page}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default Message;
